import useSWR from 'swr';

import { SWRFetcher } from '@commenda/utils';

import type {
  IAuditableServiceRequestsOptions,
  IAuditableServiceRequestsQuery,
  IFilingsAuditableServiceRequestsResponse,
} from './types';

export function useAuditableServiceRequests(
  query: IAuditableServiceRequestsQuery,
  options: IAuditableServiceRequestsOptions
) {
  const params = new URLSearchParams();
  if (query.q) params.set('q', query.q);
  if (query.filingCompositeId)
    params.set('filingCompositeId', query.filingCompositeId);
  if (query.cursor) params.set('cursor', query.cursor);
  if (query.limit) params.set('limit', String(query.limit));
  if (query.sortBy) params.set('sortBy', query.sortBy);
  if (query.sortOrder) params.set('sortOrder', query.sortOrder);
  const queryString = params.toString();

  const { data, error, isLoading, mutate } =
    useSWR<IFilingsAuditableServiceRequestsResponse>(
      `agent-platform/filings-auditor/auditable-service-requests${queryString ? `?${queryString}` : ''}`,
      SWRFetcher({ method: 'GET' }),
      { refreshInterval: options.refreshIntervalMs }
    );

  return {
    serviceRequests: data?.serviceRequests ?? [],
    nextCursor: data?.nextCursor ?? null,
    count: data?.count ?? 0,
    isLoading,
    error,
    mutate,
  };
}
